import {
  CButton,
  CCol,
  CContainer,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from "@coreui/react";
import { useState } from "react";
import { Spinner } from "react-bootstrap";
import { createItem } from "../../api/generics";
import { SUCCESS } from "../../utils/constants/tags";
import { errorAlert } from "../utils/messages";
import { CreditNote } from "../../models/credit-note";

interface CreditNoteCancellationRevertModalProps {
  show: boolean;
  creditNote?: CreditNote;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const CreditNoteCancellationRevertModal: React.FC<
  CreditNoteCancellationRevertModalProps
> = ({ show, creditNote, onCancel, onSuccess }) => {
  const [submitting, setSubmitting] = useState(false);

  const message = creditNote
    ? `Está seguro de que quiere revertir la anulación de la nota de crédito nº ${creditNote.establishmentCode}-${creditNote.dispatchPointIdentifier}-${creditNote.creditNoteNumber}?`
    : "";

  const onRetryClick = async () => {
    if (creditNote !== undefined) {
      setSubmitting(true);
      const status = await createItem(`/cancellations/revert/`, {
        taxPayerId: creditNote.taxPayerId,
        cdcs: [creditNote.cdc],
      });

      if (status.status !== SUCCESS) {
        let message = "Ha ocurrido un error!!";
        if (status.detail !== undefined) {
          message = status.detail;
        }
        errorAlert(message);
      } else {
        onSuccess();
      }

      setSubmitting(false);
    }
  };

  return (
    <CModal show={show} className="modal-success" onClosed={onCancel} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>Revertir Anulación</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <CRow>
            <CCol sm="12">
              <h2>{message}</h2>
            </CCol>
          </CRow>
        </CContainer>
      </CModalBody>
      <CModalFooter>
        <CButton disabled={submitting} onClick={onRetryClick} color="success">
          {submitting ? (
            <Spinner
              animation="grow"
              style={{
                height: "17px",
                width: "17px",
                marginTop: "auto",
                marginBottom: "auto",
                marginRight: "10px",
              }}
            />
          ) : (
            <></>
          )}
          {submitting ? "Revirtiendo..." : "Revertir"}
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default CreditNoteCancellationRevertModal;
